export default "__VITE_ASSET__DpdRjuoL__"